// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"Loading_loadingWrapper__5-NE4"};